// App
import React from 'react';

import { Box } from '@zillow/constellation-10';

// Misc / utils
import HomeMarker from '../images/icons/homeMarker.inline.svg';

type HomeDotPropTypes = {
  northSouthLat: number | null;
  eastWestLng: number | null;
  onMapMarkerMouseEnter: () => void;
  onMapMarkerMouseLeave: () => void;
  onMarkerClick: () => void;
};

const HomeDot = ({
  northSouthLat,
  eastWestLng,
  onMapMarkerMouseEnter,
  onMapMarkerMouseLeave,
  onMarkerClick,
}: HomeDotPropTypes) => {
  return (
    <Box
      css={{ pointerEvents: 'auto' }}
      northSouthLat={northSouthLat}
      eastWestLng={eastWestLng}
      onMouseEnter={onMapMarkerMouseEnter}
      onMouseLeave={onMapMarkerMouseLeave}
      onClick={onMarkerClick}
    >
      <HomeMarker width="30" height="30" style={{ background: 'transparent' }} />
    </Box>
  );
};

export default HomeDot;
